// 由 EB view/admin/src/router/modules/config.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const configRouter: RouteRecordRaw =
    {
      path: `${roterPre}/config`,
      name: 'system_config',
      meta: {
        icon: 'dashboard',
        title: '系统配置'
      },
      alwaysShow: true,
      component: Layout,
      children: [
        {
          path: 'classify',
          name: 'system_config_classify',
          meta: {
            title: '配置分类',
            noCache: true
          },
          component: () => import('@/views/system/config/classify.vue')
        },
        {
          path: 'setting',
          name: 'system_config_setting',
          meta: {
            title: '配置管理',
            noCache: true,
          },
          component: () => import('@/views/system/config/setting.vue')
        },
        {
          path: 'picture',
          name: 'system_config_picture',
          meta: {
            title: '素材管理',
            noCache: true
          },
          component: () => import('@/views/system/config/picture.vue')
        }
      ]
    }
export default configRouter;
